(function () {
  'use strict';
  if (window.__elwPosthogPilot) return;
  window.__elwPosthogPilot = true;
  const configNode = document.getElementById('elw-posthog-config');
  if (!configNode) return;
  let config, canonical;
  try {
    config = JSON.parse(configNode.textContent);
    canonical = new URL(config.canonicalUrl);
    if (canonical.origin !== location.origin || !/^phc_[A-Za-z0-9]+$/.test(config.token)) return;
    canonical.search = '';
    canonical.hash = '';
  } catch (_) { return; }

  const excluded = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|customer_authentication|checkout|checkouts|orders|password)(?:\/|$)/i;
  const templates = new Set(['index', 'product', 'collection', 'list-collections', 'cart', 'search']);
  const eventNames = new Set([
    '$snapshot', '$pageview', '$pageleave', '$autocapture', '$rageclick', '$dead_click', '$$heatmap',
    'product_view', 'variant_selected', 'add_to_cart', 'add_to_cart_failed', 'checkout_start',
    'view_cart', 'cart_updated', 'remove_from_cart', 'search_performed', 'search_result_selected',
    'collection_filter_changed', 'product_selected', 'product_info_opened', 'ui_action_failed'
  ]);
  const entryChannels = new Set(['ai_referral', 'paid_search', 'paid_social', 'organic_search', 'email', 'referral', 'direct_or_unknown', 'internal_test', 'paid_ai', 'paid_other', 'social_unknown']);
  const entrySources = new Set(['google_ads', 'meta_ads', 'chatgpt_ads', 'other_paid', 'google_organic', 'other_organic', 'meta_referral_unknown', 'chatgpt_referral', 'other_ai_referral', 'email', 'referral', 'direct_or_unknown', 'internal_test', 'legacy_unknown']);
  const entryEvidence = new Set(['utm', 'click_marker', 'referrer', 'unknown', 'legacy']);
  const chatgptCampaignBuckets = new Map([
    ['chatgpt_buffalo_24x24_202609', 'chatgpt_buffalo_24x24_original'],
    ['chatgpt_buffalo_24x24_202609_cpc_test', 'chatgpt_buffalo_24x24_cpc_test'],
    ['chatgpt_tooling_4_6sqft_202609', 'chatgpt_tooling_4_6sqft_original'],
    ['chatgpt_tooling_4_6sqft_202609_cpc_test', 'chatgpt_tooling_4_6sqft_cpc_test']
  ]);
  const campaignBuckets = new Set(chatgptCampaignBuckets.values());
  const bridgeCookies = ['elw_ph_distinct_id', 'elw_ph_session_id', 'elw_ph_context'];
  const entryKey = 'elw_ph_entry_v2';
  const publicProductText = [
    '.productView-title', '.productView-price', '.productView-info',
    '.productView-options legend', '.productView-options .product-form__label',
    '[data-open-size-chart-popup]', '[data-open-compare-color-popup]',
    '.tabs .tab-title', '.tabs [data-collapsible] .text',
    '#tab-description', '#tab-description-mobile',
    '#tab-shipping-amp-return', '#tab-shipping-amp-return-mobile'
  ].join(',');
  const publicClickSelectors = [
    '[data-cart-sidebar]', '[data-btn-addtocart]', '.product-form__label[for]',
    '[data-open-size-chart-popup]', '[data-open-compare-color-popup]',
    '.tab-title', '[data-collapsible]', '[data-show-more-toogle]',
    'form[action$="/search"] button[type="submit"]', '.card-title[href*="/products/"]',
    'input[name^="filter."]', 'select[name="sort_by"]',
    '#cart-sidebar-checkout', '#cart-checkout',
    'button[name="checkout"]', 'input[name="checkout"]', 'a[href*="/checkout"]',
    'shopify-accelerated-checkout'
  ];
  let loading = false, initializeSdk = null, sdk = null, pageSent = false;
  let entry = null, lastVariant = Number(config.variantId), recentCartSurface = null, lastCheckout = '';

  function allowed() {
    try {
      return templates.has(config.template) && !excluded.test(location.pathname) &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function safeUrl(value) {
    try {
      const parsed = new URL(value, location.origin);
      if (parsed.origin !== location.origin || excluded.test(parsed.pathname)) return null;
      parsed.search = '';
      parsed.hash = '';
      return parsed.href;
    } catch (_) { return null; }
  }
  function safeId(value) {
    value = String(value == null ? '' : value);
    return /^\d{1,30}$/.test(value) ? value : undefined;
  }
  function positive(value) {
    value = Number(value);
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
  }
  function nonNegative(value) {
    if (value === undefined || value === null || value === '') return undefined;
    value = Number(value);
    return Number.isSafeInteger(value) && value >= 0 ? value : undefined;
  }
  function finiteNonNegative(value) {
    value = Number(value);
    return Number.isFinite(value) && value >= 0 ? value : undefined;
  }
  function query() {
    try { return new URL(location.href || canonical.href).searchParams; } catch (_) { return new URLSearchParams(); }
  }
  function qaContext() {
    if (config.preview) return 'v2:preview';
    return query().get('elw_qa_canary') === '1' ? 'v2:qa' : 'v2:live';
  }
  function hostMatches(host, values) {
    return values.some(value => host === value || host.endsWith('.' + value));
  }
  function classifyEntry(params, referrer, context) {
    const result = (channel, source, evidence) => ({ channel, source, evidence, attribution_version: 3 });
    if (context !== 'v2:live') return result('internal_test', 'internal_test', 'unknown');
    const medium = String(params.get('utm_medium') || '').trim().toLowerCase();
    const source = String(params.get('utm_source') || '').trim().toLowerCase();
    const meta = /^(facebook|instagram|meta|fb|ig)$/.test(source);
    const paid = /^(cpc|ppc|paid|paid_search|paidsearch|paid_social|social_paid|paidsocial|paid_ai)$/.test(medium);
    // Explicit non-paid UTMs retain precedence over carried click markers.
    if (medium === 'email' || source === 'klaviyo' || params.has('_kx')) return result('email', 'email', 'utm');
    if (/^(organic|organic_search)$/.test(medium) && /^(google|bing|yahoo|duckduckgo|baidu|yandex|ecosia)$/.test(source)) return result('organic_search', source === 'google' ? 'google_organic' : 'other_organic', 'utm');
    if (paid && source === 'google') return result('paid_search', 'google_ads', 'utm');
    if (paid && meta) return result('paid_social', 'meta_ads', 'utm');
    if (paid && /^(chatgpt|openai)$/.test(source)) return result('paid_ai', 'chatgpt_ads', 'utm');
    const googleClick = ['gclid', 'dclid', 'gbraid', 'wbraid'].some(key => !!params.get(key)) || (params.get('elw_paid_google') === '1' && !!safeId(params.get('elw_google_campaign_id')));
    const openaiClick = !!params.get('oppref');
    if (googleClick && openaiClick) return result('paid_other', 'other_paid', 'unknown');
    if (googleClick) return result('paid_search', 'google_ads', 'click_marker');
    if (openaiClick) return result('paid_ai', 'chatgpt_ads', 'click_marker');
    if (paid || params.get('msclkid') || params.get('ttclid')) return result('paid_other', 'other_paid', paid ? 'utm' : 'click_marker');
    // A Facebook click identifier alone does not establish an ad click.
    if (meta || params.get('fbclid')) return result('social_unknown', 'meta_referral_unknown', meta ? 'utm' : 'click_marker');
    if (/^(chatgpt|openai)$/.test(source)) return result('ai_referral', 'chatgpt_referral', 'utm');
    let ref;
    try { ref = new URL(referrer); } catch (_) { return result('direct_or_unknown', 'direct_or_unknown', 'unknown'); }
    if (ref.origin === location.origin) return result('direct_or_unknown', 'direct_or_unknown', 'unknown');
    const host = ref.hostname.toLowerCase();
    if (hostMatches(host, ['chatgpt.com', 'chat.openai.com'])) return result('ai_referral', 'chatgpt_referral', 'referrer');
    if (hostMatches(host, ['perplexity.ai', 'claude.ai', 'gemini.google.com', 'copilot.microsoft.com', 'you.com'])) return result('ai_referral', 'other_ai_referral', 'referrer');
    if (hostMatches(host, ['facebook.com', 'instagram.com', 'fb.com'])) return result('social_unknown', 'meta_referral_unknown', 'referrer');
    if (hostMatches(host, ['google.com', 'google.co.uk', 'google.ca', 'google.com.au', 'google.de', 'google.fr'])) return result('organic_search', 'google_organic', 'referrer');
    if (hostMatches(host, ['bing.com', 'search.yahoo.com', 'duckduckgo.com', 'baidu.com', 'yandex.com', 'ecosia.org'])) return result('organic_search', 'other_organic', 'referrer');
    return result('referral', 'referral', 'referrer');
  }
  function chatgptCampaignBucket(params, attribution) {
    if (attribution.source !== 'chatgpt_ads' || attribution.evidence !== 'utm') return undefined;
    return chatgptCampaignBuckets.get(params.get('utm_campaign'));
  }
  function makeEntry(sessionId) {
    const params = query(), context = qaContext();
    const attribution = classifyEntry(params, document.referrer || '', context);
    const campaign = ['utm_id', 'campaign_id', 'campaignid', 'gad_campaignid', 'utm_campaign', 'elw_google_campaign_id'].map(key => safeId(params.get(key))).find(Boolean);
    const ad = ['ad_id', 'adid'].map(key => safeId(params.get(key))).find(Boolean);
    return {
      url: safeUrl(location.href || canonical.href) || canonical.href,
      ...attribution,
      campaign_id: campaign,
      campaign_bucket: chatgptCampaignBucket(params, attribution),
      ad_id: ad,
      context: context,
      session_id: sessionId
    };
  }
  function validEntry(value) {
    if (!value || !entryChannels.has(value.channel) || !safeUrl(value.url)) return null;
    if (!/^v2:(?:live|preview|qa)$/.test(value.context || '')) return null;
    if (value.session_id !== undefined && !/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value.session_id)) return null;
    const sessionId = value.session_id;
    return { url: safeUrl(value.url), channel: value.channel, campaign_id: safeId(value.campaign_id), campaign_bucket: campaignBuckets.has(value.campaign_bucket) ? value.campaign_bucket : undefined, ad_id: safeId(value.ad_id), context: value.context, session_id: sessionId,
      source: value.attribution_version === 3 && entrySources.has(value.source) ? value.source : 'legacy_unknown',
      evidence: value.attribution_version === 3 && entryEvidence.has(value.evidence) ? value.evidence : 'legacy',
      attribution_version: value.attribution_version === 3 ? 3 : 2 };
  }
  function ensureEntry() {
    if (entry) return entry;
    try { entry = validEntry(JSON.parse(window.sessionStorage.getItem(entryKey))); } catch (_) { /* unavailable or empty */ }
    entry = entry || makeEntry();
    try { window.sessionStorage.setItem(entryKey, JSON.stringify(entry)); } catch (_) { /* analytics still works without persistence */ }
    return entry;
  }
  function deleteBridge() {
    for (const name of bridgeCookies) document.cookie = name + '=; Path=/; SameSite=Lax; Secure; Max-Age=0';
  }
  function clearEntry() {
    entry = null;
    try { window.sessionStorage.removeItem(entryKey); } catch (_) { /* storage may be unavailable */ }
  }
  function bindEntryToSession(sessionId) {
    const current = ensureEntry();
    if (current.session_id && current.session_id !== sessionId) entry = makeEntry(sessionId);
    else current.session_id = sessionId;
    try { window.sessionStorage.setItem(entryKey, JSON.stringify(entry)); } catch (_) { /* analytics still works without persistence */ }
    return entry;
  }
  function writeBridge() {
    if (!sdk || !allowed()) return deleteBridge();
    let distinct = '', session = '';
    try { distinct = String(sdk.get_distinct_id()); session = String(sdk.get_session_id()); } catch (_) { return deleteBridge(); }
    const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    const uuid7 = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!uuid.test(distinct) || !uuid7.test(session)) return deleteBridge();
    const values = { elw_ph_distinct_id: distinct, elw_ph_session_id: session, elw_ph_context: bindEntryToSession(session).context };
    for (const name of bridgeCookies) document.cookie = name + '=' + values[name] + '; Path=/; SameSite=Lax; Secure';
  }
  function scrubBag(bag) {
    if (!bag) return bag;
    const first = ensureEntry().url;
    if ('$current_url' in bag) bag.$current_url = safeUrl(bag.$current_url) || canonical.href;
    for (const key of ['$initial_current_url', '$session_entry_url']) if (key in bag) bag[key] = first;
    if ('$pathname' in bag) {
      try { bag.$pathname = new URL(bag.$current_url || canonical.href).pathname; } catch (_) { bag.$pathname = canonical.pathname; }
    }
    for (const key of Object.keys(bag)) {
      if (/referr|^utm_|^\$initial_utm_|^(gclid|dclid|gbraid|wbraid|fbclid|ttclid|msclkid|oppref|_kx|elw_paid_google|elw_google_campaign_id|email|phone|\$ip)$/i.test(key)) delete bag[key];
    }
    return bag;
  }
  function scrubElements(properties) {
    const elements = Array.isArray(properties.$elements) ? properties.$elements.slice(0, 8).map(element => ({
      tag_name: /^[a-z][a-z0-9-]*$/i.test(element.tag_name || '') ? element.tag_name.toLowerCase() : 'unknown',
      nth_child: nonNegative(element.nth_child),
      nth_of_type: nonNegative(element.nth_of_type)
    })) : [];
    properties.$elements = elements;
    properties.$elements_chain = elements.map(element => element.tag_name + ':nth-child(' + (element.nth_child || 0) + ')').join(';');
    delete properties.$el_text;
    delete properties.$external_click_url;
    delete properties.$element_selectors;
  }
  function scrubHeatmap(properties) {
    const clean = {};
    const source = properties.$heatmap_data;
    if (source && typeof source === 'object') for (const rawUrl of Object.keys(source)) {
      const url = safeUrl(rawUrl);
      if (!url || !Array.isArray(source[rawUrl])) continue;
      const points = source[rawUrl].map(point => ({
        x: finiteNonNegative(point.x), y: finiteNonNegative(point.y), target_fixed: point.target_fixed === true,
        type: /^(?:click|mousemove|deadclick|rageclick)$/.test(point.type) ? point.type : undefined
      })).filter(point => point.x !== undefined && point.y !== undefined && point.type);
      if (points.length) clean[url] = (clean[url] || []).concat(points);
    }
    properties.$heatmap_data = clean;
  }
  function commonProperties() {
    const first = ensureEntry();
    const result = {
      $current_url: canonical.href, $pathname: canonical.pathname,
      $session_entry_url: first.url, $initial_current_url: first.url,
      entry_path: new URL(first.url).pathname, entry_channel: first.channel,
      entry_source: first.source, entry_source_evidence: first.evidence, attribution_version: first.attribution_version,
      template: config.template, theme_id: config.themeId,
      elw_preview: config.preview === true, qa_canary: first.context !== 'v2:live',
      event_schema_version: 2, pilot_version: 2
    };
    if (first.campaign_id) result.campaign_id = first.campaign_id;
    if (first.campaign_bucket) result.campaign_bucket = first.campaign_bucket;
    if (first.ad_id) result.ad_id = first.ad_id;
    return result;
  }
  function beforeSend(event) {
    if (!event || !allowed() || !eventNames.has(event.event)) return null;
    writeBridge();
    event.properties = scrubBag(event.properties || {});
    if (event.event === '$autocapture' || event.event === '$rageclick' || event.event === '$dead_click') scrubElements(event.properties);
    if (event.event === '$$heatmap') scrubHeatmap(event.properties);
    Object.assign(event.properties, commonProperties());
    event.properties.$geoip_disable = true;
    scrubBag(event.$set); scrubBag(event.$set_once);
    scrubBag(event.properties.$set); scrubBag(event.properties.$set_once);
    return event;
  }
  function scrubReplayUrl(request) {
    request.requestHeaders = request.responseHeaders = undefined;
    request.requestBody = request.responseBody = undefined;
    if (!request.name) return request;
    const url = safeUrl(request.name);
    if (!url) return null;
    request.name = url;
    return request;
  }
  function maskReplayText(value, element) {
    try {
      if (config.template === 'product' && element && element.closest && element.closest(publicProductText)) return value;
    } catch (_) { /* default to masking */ }
    return value.replace(/\S/g, '*');
  }
  function capture(name, properties) {
    if (!sdk || !allowed()) return;
    writeBridge();
    sdk.capture(name, Object.assign(commonProperties(), properties));
  }
  function syncConsent() {
    if (!allowed()) {
      deleteBridge();
      clearEntry();
      if (sdk) { sdk.stopSessionRecording(); sdk.opt_out_capturing(); }
      return;
    }
    ensureEntry();
    if (sdk) {
      sdk.opt_in_capturing({ captureEventName: false });
      sdk.startSessionRecording();
      writeBridge();
      if (!pageSent) {
        pageSent = true;
        capture('$pageview');
        if (config.template === 'product') capture('product_view', { product_id: positive(config.productId), variant_id: positive(config.variantId) });
        if (config.template === 'cart') capture('view_cart', { surface: 'cart_page' });
        if (config.template === 'search' && config.searchPerformed) {
          const count = nonNegative(config.searchResultsCount) || 0;
          capture('search_performed', { result_count: count, zero_results: count === 0 });
        }
      }
      return;
    }
    if (initializeSdk) {
      const initialize = initializeSdk;
      initializeSdk = null;
      initialize();
      return;
    }
    if (loading || window.posthog) return;
    loading = true;
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.onerror = function () { loading = false; };
    script.onload = function () {
      loading = false;
      if (!window.posthog) return;
      initializeSdk = function () { window.posthog.init(config.token, {
        api_host: 'https://us.i.posthog.com', defaults: '2026-08-30',
        opt_out_capturing_by_default: true, opt_out_persistence_by_default: true,
        persistence: 'sessionStorage', cross_subdomain_cookie: false, person_profiles: 'never',
        autocapture: { dom_event_allowlist: ['click'], css_selector_allowlist: publicClickSelectors },
        mask_all_text: true, mask_all_element_attributes: true,
        capture_pageview: false, capture_pageleave: true,
        capture_dead_clicks: true, rageclick: true, capture_exceptions: false, capture_heatmaps: true,
        capture_performance: false, enable_recording_console_log: false,
        logs: { captureConsoleLogs: false }, save_campaign_params: false, save_referrer: false,
        disable_capture_url_hashes: true, disable_surveys: true, disable_product_tours: true,
        disable_web_experiments: true, opt_in_site_apps: false,
        session_recording: {
          ...(config.preview ? { sampleRate: 1 } : {}),
          maskAllInputs: true, maskTextSelector: '*', maskTextFn: maskReplayText,
          maskAllElementAttributes: false,
          maskAttributeFn: function (name, value) {
            if (/^(class|id|type|role|width|height|aria-hidden|tabindex|rr_.*)$/.test(name)) return value;
            if (name === 'media' && /^(?:all|screen|print|not all)$/i.test(value)) return value.toLowerCase();
            if (name === 'style' || name === '_cssText') return value.replace(/url\([^)]*\)/gi, 'none');
            return '*'.repeat(value.length);
          },
          blockSelector: 'img,picture,video,audio,canvas,svg,iframe,object,embed,input[type="hidden"],input[type="file"],[data-ph-sensitive]',
          recordHeaders: false, recordBody: false, collectFonts: false,
          recordCrossOriginIframes: false, captureJsonLd: false, captureCanvas: { recordCanvas: false },
          maskCapturedNetworkRequestFn: scrubReplayUrl
        },
        before_send: beforeSend,
        loaded: function (instance) { sdk = instance; syncConsent(); }
      }); };
      syncConsent();
    };
    document.head.appendChild(script);
  }

  function cartPath(url) {
    try {
      const parsed = new URL(url, location.origin);
      if (parsed.origin !== location.origin) return null;
      const match = parsed.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/(add|change|update)(?:\.js)?\/?$/i);
      return match && match[1].toLowerCase();
    } catch (_) { return null; }
  }
  function surfaceFor(target) {
    if (!target || !target.closest) return config.template === 'cart' ? 'cart_page' : 'unknown';
    if (target.closest('shopify-accelerated-checkout,.shopify-payment-button,[data-shopify="payment-button"]')) return config.template === 'product' ? 'product_express' : 'accelerated_checkout';
    if (target.closest('#halo-cart-sidebar,.halo-cart-sidebar')) return 'cart_drawer';
    if (target.closest('[data-quickshop],[data-product-list-view]')) return 'quick_view';
    const form = target.closest('form');
    if (form && /product-form-sticky-/.test(form.getAttribute('id') || '')) return 'sticky_product';
    if (config.template === 'product') return 'product_page';
    if (config.template === 'cart') return 'cart_page';
    return 'collection_quick_add';
  }
  function rememberCartSurface(target) {
    recentCartSurface = { value: surfaceFor(target), time: Date.now() };
  }
  function cartSurface() {
    return recentCartSurface && Date.now() - recentCartSurface.time < 5000 ? recentCartSurface.value : (config.template === 'cart' ? 'cart_page' : 'cart_drawer');
  }
  function reportCartAdd(status, data) {
    const surface = cartSurface();
    if (status < 200 || status >= 300 || !data || data.status >= 400) {
      capture('add_to_cart_failed', { failure_reason: status === 0 ? 'network' : 'rejected', surface: surface });
      return;
    }
    for (const item of Array.isArray(data.items) ? data.items : [data]) {
      const variant = positive(item.variant_id || item.id), quantity = positive(item.quantity);
      if (variant && quantity) capture('add_to_cart', { variant_id: variant, quantity: quantity, product_id: positive(item.product_id), surface: surface });
    }
  }
  function requestedQuantity(body) {
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) return nonNegative(body.get('quantity'));
      if (typeof body === 'string') {
        if (/^\s*\{/.test(body)) return nonNegative(JSON.parse(body).quantity);
        return nonNegative(new URLSearchParams(body).get('quantity'));
      }
      if (body && typeof body === 'object') return nonNegative(body.quantity);
    } catch (_) { /* unknown request body */ }
  }
  function reportCartMutation(kind, status, data, body) {
    const quantity = requestedQuantity(body), operation = quantity === 0 ? 'cart_remove' : 'cart_update';
    const surface = config.template === 'cart' ? 'cart_page' : 'cart_drawer';
    if (status < 200 || status >= 300 || !data || data.status >= 400 || data.errors) {
      capture('ui_action_failed', { operation: operation, failure_reason: status === 0 ? 'network' : 'rejected', surface: surface });
      return;
    }
    const props = { surface: surface, item_count: nonNegative(data.item_count) };
    if (quantity !== undefined) props.quantity = quantity;
    capture(quantity === 0 ? 'remove_from_cart' : 'cart_updated', props);
  }
  function observeCartResponse(kind, status, data, body) {
    if (kind === 'add') reportCartAdd(status, data);
    else reportCartMutation(kind, status, data, body);
  }
  if (window.jQuery) window.jQuery(document).on('ajaxComplete.elwPosthog', function (_, xhr, settings) {
    const kind = cartPath(settings.url);
    if (allowed() && kind && /post/i.test(settings.type || '')) observeCartResponse(kind, xhr.status, xhr.responseJSON, settings.data);
  });
  const originalFetch = window.fetch;
  if (originalFetch) window.fetch = function (input, init) {
    const pending = originalFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' || input instanceof URL ? input : input.url;
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const kind = cartPath(url);
      if (allowed() && kind && method === 'POST') {
        const body = (init && init.body) || (input && input.body);
        pending.then(response => response.clone().json().then(data => observeCartResponse(kind, response.status, data, body)),
          () => observeCartResponse(kind, 0, null, body)).catch(() => {});
      }
    } catch (_) { /* Analytics must never change the fetch caller's outcome. */ }
    return pending;
  };

  function resolvedVariant(input) {
    const root = input.closest && input.closest('variant-radios,variant-selects,variant-sticky-radios,variant-sticky-selects,[data-quickshop]');
    const product = positive((root && root.getAttribute && root.getAttribute('data-product')) || config.productId);
    let selected;
    try {
      const form = input.form || (input.closest && input.closest('form'));
      selected = form && form.querySelector('[name="id"]');
    } catch (_) { /* use the changed control */ }
    return { product_id: product, variant_id: positive((selected && selected.value) || input.getAttribute('data-variant-id') || input.value), surface: surfaceFor(input) };
  }
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input.matches) return;
    if (input.matches('input[data-variant-id],select[name="id"],input[name="id"]')) setTimeout(function () {
      const selected = resolvedVariant(input);
      if (selected.variant_id && selected.variant_id !== lastVariant) {
        lastVariant = selected.variant_id;
        capture('variant_selected', selected);
      }
    }, 0);
    if (input.matches('input[name^="filter."],select[name="sort_by"]')) {
      let count;
      try { count = document.querySelectorAll('input[name^="filter."]:checked').length; } catch (_) { count = 0; }
      const filterKeys = {
        'filter.v.price.gte': 'price_min', 'filter.v.price.lte': 'price_max',
        'filter.v.option.color': 'color', 'filter.v.option.size': 'size',
        'filter.v.t.shopify.material': 'material', 'filter.p.tag': 'tag', 'sort_by': 'sort'
      };
      const filterKey = filterKeys[input.getAttribute('name')] || 'other';
      capture('collection_filter_changed', {
        action: input.matches('select[name="sort_by"]') ? 'sort' : (input.checked ? 'apply' : 'remove'),
        filter_key: filterKey, filter_count: nonNegative(count), surface: input.closest && input.closest('.mobile-facets') ? 'mobile' : 'desktop'
      });
    }
  });
  function captureCheckout(surface) {
    const key = surface + ':' + Math.floor(Date.now() / 1000);
    if (key === lastCheckout) return;
    lastCheckout = key;
    capture('checkout_start', { stage: 'click_intent', surface: surface });
  }
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.getAttribute) return;
    const action = form.getAttribute('action') || '';
    if (cartPath(action) === 'add') rememberCartSurface(form);
    try {
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkouts?\/?$/i.test(new URL(action || location.href, location.origin).pathname)) captureCheckout(surfaceFor(form));
    } catch (_) { /* invalid form action */ }
  }, true);
  function productCard(link) {
    const card = link.closest && (link.closest('.product-card-wrapper') || link.closest('.product,.product-item,.card'));
    if (!card) return {};
    const idNode = card.querySelector && card.querySelector('[data-product-id],[ymq-b2b-product-id]');
    const productId = positive((idNode && (idNode.getAttribute('data-product-id') || idNode.getAttribute('ymq-b2b-product-id'))) || card.getAttribute('data-product-id'));
    const predictive = card.closest && card.closest('[data-predictive-search],.quickSearchResultsWrap');
    const container = predictive || (card.closest && card.closest('#product-grid,#main-collection-product-grid,[data-product-grid],.products-grid,[data-product-block],.grid-layout'));
    const cardRoot = card.matches && card.matches('.product-card-wrapper') ? card : ((card.closest && card.closest('.product')) || card);
    const cardSelector = cardRoot === card && card.matches && card.matches('.product-card-wrapper') ? '.product-card-wrapper' : '.product';
    const cards = container && container.querySelectorAll ? Array.from(container.querySelectorAll(cardSelector)) : [];
    const index = cards.indexOf(cardRoot);
    return { product_id: productId, result_position: index >= 0 ? index + 1 : undefined, result_count: cards.length || undefined, container: container };
  }
  function captureProductSelection(link) {
    const details = productCard(link);
    if (!details.product_id) return;
    const predictive = details.container && details.container.matches && details.container.matches('[data-predictive-search],.quickSearchResultsWrap');
    const props = { product_id: details.product_id, result_position: details.result_position, result_count: details.result_count };
    if (predictive || config.template === 'search') {
      props.surface = predictive ? 'predictive_search' : 'search_results';
      if (config.template === 'search') props.result_count = nonNegative(config.searchResultsCount);
      capture('search_result_selected', props);
    } else {
      props.placement = config.template === 'collection' ? 'collection_grid' : 'recommendation';
      capture('product_selected', props);
    }
  }
  function productInfo(target) {
    const href = target.getAttribute && target.getAttribute('href') || '';
    let section;
    if (target.matches('[data-open-size-chart-popup]')) section = 'sizing';
    else if (target.matches('[data-open-compare-color-popup]')) section = 'swatch';
    else if (/shipping-amp-return/.test(href)) section = 'shipping_returns';
    else if (/tab-description/.test(href)) section = 'description';
    if (!section) return;
    capture('product_info_opened', {
      product_id: positive(config.productId), section: section,
      surface: target.matches('[data-open-size-chart-popup],[data-open-compare-color-popup]') ? 'product_tool' : (target.matches('[data-show-more-toogle]') ? 'read_more' : (target.matches('[data-collapsible]') ? 'mobile_accordion' : 'desktop_tabs'))
    });
  }
  document.addEventListener('click', function (event) {
    const raw = event.target;
    const target = raw.closest && raw.closest('a[href],button,input,[data-cart-sidebar],[data-btn-addtocart],.tab-title,[data-collapsible],[data-show-more-toogle],[data-open-size-chart-popup],[data-open-compare-color-popup],shopify-accelerated-checkout');
    if (!target) return;
    if (target.matches('[data-btn-addtocart],button[name="add"],input[name="add"]')) rememberCartSurface(target);
    if (target.matches('[data-cart-sidebar]')) capture('view_cart', { surface: 'cart_drawer' });
    if (target.matches('.tab-title,[data-collapsible],[data-show-more-toogle],[data-open-size-chart-popup],[data-open-compare-color-popup]')) productInfo(target);
    if (target.matches('a[href*="/products/"]')) captureProductSelection(target);
    let checkout = target.matches('#cart-sidebar-checkout,#cart-checkout,button[name="checkout"],input[name="checkout"],shopify-accelerated-checkout') || !!target.closest('.shopify-payment-button,[data-shopify="payment-button"]');
    if (!checkout && target.href) {
      try { checkout = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkouts?(?:\/|$)/i.test(new URL(target.href, location.origin).pathname); } catch (_) { checkout = false; }
    }
    if (checkout) captureCheckout(surfaceFor(target));
  }, true);
  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('popstate', syncConsent);
  if (window.Shopify && window.Shopify.customerPrivacy) syncConsent();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) syncConsent(); });
  }
})();
